<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta MasterCard
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Tu solicitud ha sido rechazada</label>
                    </div>
                </div>    
                <div class="text-center" style="margin-top: 10px">
                    <img src="@/assets/card_landing.png" class="mx-auto d-block" width="40%" height="40%" />
                </div>
                <div class="col-md-12 text-center">
                        <label><b>Motivo</b></label>
                </div>
                <div class="col-md-12 text-center">
                        <label class="col-md-8">{{reason}}</label>
                </div>
                <br>
                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <base-button type="danger" size="md" @click="solicitarDeNuevo">Solicitar de nuevo</base-button>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style scoped>
.btn-danger {
    border-color:#ff5855; 
    background-color:#ff5855;
}
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    export default {
        components: { 
        },
        props: {     
            reason: {
                type: String,
                default: "",
                description: "Motivo de rechazo de solicitud"
            }
        },
        data(){
            return{
                model: {                  
                },
                RejectedReason: "",
            }
        },
        methods: {
            solicitarDeNuevo() {
                let context = this
                context.$router.push({
                name: "MyPrepaidCard",
                params: { requestAgain: true }});
            }
        }
    }
</script>